<template>
  <div class="common-home-content">
    <div ref="imageWrapper">
      <div
        class="set-defalut-survey space_pl space_pr"
        v-if="!user_id"
        @click="setDefalutSurvey"
      >
        设置默认问诊单<span class="gengd-icon"></span>
      </div>
      <p class="survey-title space_pl space_pr">我的问诊单</p>
      <ul class="survey-ul space_pl space_pr">
        <li
          v-for="(child, index) in surveys"
          :key="index"
          @click="handlePreview(child)"
        >
          <p class="name">
            <span class="name-pr"
              >{{ child.title
              }}<span class="default-icon" v-if="defalutMark(child)">{{
                defalutMark(child)
              }}</span></span
            >
          </p>
          <p class="questions">共{{ child.question_count }}个问题</p>
          <button class="send-survey" @click.stop="sendSurvey(child)"></button>
        </li>
      </ul>
      <Loading :value="shows" />
    </div>
  </div>
</template>
<script>
import http from "../../util/heraApiConfig";
import uniUrl from "../../util/uniUrl";
import { addBridgeForAndroidWebView } from "sdbridge-android";
import Loading from "../loading/loading";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      show: false,
      shows: true,
      surveyData: {},
      doctor_id: "",
      user_id: false,
      token: "",
      surveys: [],
      system_surveys: [],
      chat: "",
      isApp: "",
      platform_type:2,
    };
  },
  created() {
    let bridge = window.WebViewJavascriptBridge;
    if (!bridge) {
      console.log(
        "window.WebViewJavascriptBridge 没有挂载成功！！,TS正在尝试挂载"
      );
      console.log("TypeScript正在尝试挂载");
      addBridgeForAndroidWebView();
      //@ts-ignore
      bridge = window.WebViewJavascriptBridge;
      if (bridge) {
        console.log(
          "window.WebViewJavascriptBridge, 已经被TypeScript挂载成功！！"
        );
      }
    } else {
      console.log("window.WebViewJavascriptBridge 挂载成功！！");
    }
    this.chat = this.$route.query.chat;
    if (this.$route.query.user_id) {
      this.user_id = this.$route.query.user_id;
      console.log(this.user_id);
      this.isApp = this.$appUtils.isApp();
      if (this.isApp == "IOS") {
        bridge.callHandler("showTrBtn", { name: "" }, (response) => {});
        bridge.callHandler("getUserInfo", "", (response) => {
          this.token = response.token;
          this.doctor_id = response.doctor_id;
          this.platform_type = response.platform_type;
        });
      } else if (this.isApp == "android") {
        this.$appUtils.showAppTrBtn({});
        var user_info = this.$appUtils.appData();
        if (user_info) {
          this.token = user_info.token;
          this.platform_type = user_info.platform_type;
          this.doctor_id = user_info.doctor_id;
        }
      }
    } else {
      this.isApp = this.$appUtils.isApp();
      if (this.isApp == "IOS") {
        bridge.callHandler("showTrBtn", { name: "新建" }, (response) => {});
        bridge.callHandler("getUserInfo", "", (response) => {
          this.token = response.token;
          this.doctor_id = response.doctor_id;
          this.platform_type = response.platform_type;
        });
        bridge.registerHandler("buildSurvey", (data, responseCallback) => {
          this.buildSurvey();
        });
        bridge.registerHandler("pageback", (data, responseCallback) => {
          this.pageback();
        });
      } else if (this.isApp == "android") {
        this.$appUtils.showAppTrBtn({ name: "新建" });
        var user_info = this.$appUtils.appData();
        if (user_info) {
          this.token = user_info.token;
          this.doctor_id = user_info.doctor_id;
          this.platform_type = user_info.platform_type;
        }
      }
    }
    if (this.$route.query.type == "uniapp") {
      this.doctor_id = this.$route.query.doctor_id;
      this.token = this.$route.query.token;
    }
    window.appTrBtnClick = () => this.buildSurvey();
    window.appBack = () => this.pageback();
    localStorage.removeItem("is_new_build_survey_status");
    setTimeout(() => {
      this.getDate();
    }, 1000);
  },
  methods: {
    defalutMark(item) {
      let list = [];
      if (item["tag_women"]) {
        list.push("成女");
      }
      if (item["tag_man"]) {
        list.push("成男");
      }
      if (item["tag_child"]) {
        list.push("小儿");
      }
      if (list.length > 0) {
        return list.join("、") + "·默认";
      } else {
        return false;
      }
    },
    getDate() {
      let that = this;
      let params = {
        doctor_id: that.doctor_id,
      };
      http
        .get("/surveys/surveys"+'?platform_type=' +this.platform_type, {
          params: params,
          headers: {
            Authorization: that.token,
          },
        })
        .then(function (res) {
          that.shows = false;
          console.log(JSON.stringify(res.data));
          that.surveys = res.data.data;
          that.show = true;
          that.$appUtils.appCloseLoadingView();
        });
    },
    buildSurvey() {
      localStorage.removeItem("survey_id");
      localStorage.removeItem("local_survey_question");
      localStorage.setItem("is_new_build_survey_status", true);
      this.$router.push({ path: "/buildsurvey" });
    },
    setDefalutSurvey() {
      let bridge = window.WebViewJavascriptBridge;
      this.$router.push({ path: "/defalutsurvey" });
      if (this.isApp == "IOS") {
        console.log("进入ios");
        bridge.callHandler("showTrBtn", { name: "" }, (response) => {});
      }
    },
    handlePreview(item) {
      console.log(item);
      if (item.is_system) {
        this.$router.push({
          path: "/systempreview/" + item.survey_id,
          query: { survey_name: item.title },
        });
      } else {
        this.$router.push({
          path: "/buildpreview/" + item.survey_id,
          query: { survey_name: item.title, user_id: this.user_id },
        });
      }
    },
    sendSurvey(item) {
      let bridge = window.WebViewJavascriptBridge;
      this.isApp = this.$appUtils.isApp();
      if (this.isApp == "IOS") {
        if (this.user_id) {
          bridge.callHandler("sendSurvey", {
            survey_id: item["survey_id"],
            user_id: this.user_id,
          });
        } else {
          bridge.callHandler("sendSurvey", { survey_id: item["survey_id"] });
        }
      }
      if (this.user_id) {
        this.$appUtils.appSendSurvey({
          survey_id: item["survey_id"],
          user_id: this.user_id,
        });
      } else {
        this.$appUtils.appSendSurvey({ survey_id: item["survey_id"] });
      }
      if (this.$route.query.type == "uniapp") {
        if (this.$route.query.detail == "true") {
          window.open(
            uniUrl +
              "pages/chat/chat?item=" +
              JSON.stringify(item) +
              "&chat=" +
              this.chat +
              "&type=1"
          );
        } else {
          console.log(this.chat, "this.chat");
          window.open(
            uniUrl +
              "pages/chatSearch/chatSearch?item=" +
              JSON.stringify(item) +
              "&chat=" +
              this.chat +
              "&type=3"
          );
        }
      }
    },
    pageback() {
      window.history.back();
      return null;
    },
  },
};
</script>
<style lang="scss" scoped>
.new-build-survey {
  width: 32px;
  line-break: 16px;
  font-size: 16px;
  font-family: PingFang-SC-Bold;
  font-weight: bold;
  color: rgba(172, 75, 56, 1);
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 14px;
}
.set-defalut-survey {
  width: 100%;
  line-height: 56px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: PingFang-SC-Bold;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  border-bottom: 2px solid #e6e6e6;
  position: relative;
}
.gengd-icon {
  display: block;
  width: 6px;
  height: 10px;
  background: url("../../assets/images/survey/gengd.png") no-repeat;
  background: none\9;
  background-size: 6px 10px;
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
}
.survey-title {
  margin: 25px 0 16px;
  line-height: 17px;
  font-size: 18px;
  font-family: PingFang-SC-Bold;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}
.survey-ul {
  width: 100%;
  box-sizing: border-box;
  & > li {
    margin-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
    padding: 20px 20px 20px 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 5px 1px rgba(35, 24, 21, 0.15);
    border-radius: 10px;
    position: relative;
    .name {
      line-height: 16px;
      font-size: 16px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      .name-pr {
        display: inline-block;
        position: relative;
      }
      .default-icon {
        display: inline-block;
        padding: 5px 6px;
        line-height: 12px;
        font-size: 12px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        color: rgba(188, 62, 32, 1);
        background: rgba(253, 236, 233, 1);
        border-radius: 11px;
        position: relative;
        top: 0;
        right: -5px;
      }
    }
    .questions {
      margin-top: 25px;
      line-height: 14px;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
    }
    .send-survey {
      width: 27px;
      height: 27px;
      background: url("../../assets/images/survey/send.png") no-repeat;
      background: none\9;
      background-size: 27px 27px;
      margin: auto;
      position: absolute;
      right: 10px;
      top: 0;
      bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/surveylist.vue